import React from 'react';

interface Props {
  companyName: string;
}

const NaverAppClauseV1: React.FC<Props> = ({ companyName }) => {
  return (
    <div className="p-3">
      <h2 className="fs-4 mb-3">{companyName} N-PASS 제 3자 동의</h2>
      <div className="agree-wrap">
        <div className="agree-box full-height">
          <div className="terms-wrap">
            <p>
              N-Pass 서비스 이용을 위해 아래와 같이 개인정보를 제3자에게 제공합니다.
            </p>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '12px',
                marginBottom: '12px',
                fontSize: '15px',
                lineHeight: 1.6,
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      border: '1px solid #d1d5db',
                      backgroundColor: '#f8fafc',
                      padding: '10px 12px',
                      textAlign: 'left',
                      width: '22%',
                      fontWeight: 700,
                    }}
                  >
                    항목
                  </th>
                  <th
                    style={{
                      border: '1px solid #d1d5db',
                      backgroundColor: '#f8fafc',
                      padding: '10px 12px',
                      textAlign: 'left',
                      fontWeight: 700,
                    }}
                  >
                    내용
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tableCellStyle}>제공받는 자</td>
                  <td style={tableCellStyle}>
                    N-Pass 서비스 이용 고객사 ({companyName}) (이벤트/캠페인 주관 광고주)
                  </td>
                </tr>
                <tr>
                  <td style={tableCellStyle}>제공 목적</td>
                  <td style={tableCellStyle}>회원 유치 및 리텐션 마케팅</td>
                </tr>
                <tr>
                  <td style={tableCellStyle}>제공 항목</td>
                  <td style={tableCellStyle}>이름, 휴대전화번호, 이메일</td>
                </tr>
                <tr>
                  <td style={tableCellStyle}>보유·이용기간</td>
                  <td style={tableCellStyle}>
                    이용 목적 달성 시 또는 동의 철회 시 즉시 파기
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              제3자 제공에 동의하지 않으실 경우, 해당 캠페인의 광고·이벤트·혜택
              안내 등 알림 서비스를 받으실 수 없습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const tableCellStyle: React.CSSProperties = {
  border: '1px solid #d1d5db',
  padding: '10px 12px',
  verticalAlign: 'top',
  wordBreak: 'keep-all',
};

export default NaverAppClauseV1;
